import React, { Component } from "react";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import { getFileStatus } from "../../utils/fileStatus";
import { callApi } from "../../utils/api";
import ExcelRectificationReport from "./ExcelRectificationReport";
interface AllProps {
    reports: any;
    getBranch: any;
    redirectToDashboard?: any;
}
export default class RectificationReportTable extends Component<AllProps> {
    state = {
        users: [],
    }

    componentDidMount() {
        this.getUsers();

    }
    getUsers = () => {
        callApi("GET", "user_get.php")
            .then((res) => res.data)
            .then((response) => {
                this.setState({ users: response.data });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    getNameById(id) {
        const { users }: any = this.state;
        for (let i = 0; i < users.length; i++) {
            if (users[i].id === id) {
                return users[i].name;
            }
        }
        return "";
    }

    render() {
        const { reports = [], redirectToDashboard = () => { } } = this.props;
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();
        const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
        return (
            <div className="">
                <div className="row">
                    <div className="col-xl-12 col-md-12 p-3">
                        {reports && reports.length > 0 && <ExcelRectificationReport data={reports} />}
                    </div>
                </div>
                <div className="dt-responsive table-responsive" style={{ overflow: 'auto' }}>
                    <table style={{ overflowX: "scroll", width: "140%" }} id="processeodTable" className="table table-striped table-bordered nowrap">
                        <thead>
                            <tr>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Sl.No</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>File No</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Law Hands Branch</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Bank Name</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Product</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Bank Branch Name</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Borrower Name</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Property Owner Name</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Process Officer</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Verification Officer</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Double Verification Officer</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Rectification Login Date and Time</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Rectification Received Date and Time</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>File Picked By</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>File Initial Status</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>File Completion Status</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>File Picked Date and Time</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>File Completed Date and Time</th>
                                {/* <th style={{ position: 'sticky', top: 0, background: 'white' }}>File Queue Time</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>File Working Time</th> */}
                                {/* <th style={{ position: 'sticky', top: 0, background: 'white' }}>Mistakes Made by</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Rectification Category</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Rectification Sub Category</th> */}
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Rectification Reason</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reports && reports.length
                                ? reports.map(
                                    (query: any, index: number) => {
                                        const rectifyData = query.rectify_data;
                                        let rectifyById = "";

                                        if (rectifyData && rectifyData.length > 0) {
                                            rectifyById = rectifyData[0].rectify_by;
                                        }
                                        return (
                                            <tr className="query-table-row cursor-pointer" key={index}>
                                                <td className="text-align-center">{index + 1}</td>
                                                <td className="click">{query.file_no ? query.file_no : ""}</td>
                                                <td className="click">{query.lh_branch}</td>
                                                <td className="click">{query.bank_name}</td>
                                                <td className="click">{query.product_name}</td>
                                                <td className="click">{query.branch_name}</td>
                                                <td className="click">{query.borrower_name}</td>
                                                <td className="click">{query.property_owner}</td>
                                                <td className="click">{query.po_name}</td>
                                                <td className="click">{query.vo_name}</td>
                                                <td className="click">{query.dvo_name}</td>
                                                <td className="click">{query.created_dt}</td>
                                                <td className="click">{query.arrived_dt}</td>
                                                <td className="click">{query.picked_by}</td>
                                                <td className="click">{query.initial_status}</td>
                                                <td className="click">{query.completed_status}</td>
                                                <td className="click">{query.picked_dt}</td>
                                                <td className="click">{query.completed_dt}</td>
                                                {/* <td className="click">{query.queue_time}</td>
                                                <td className="click">{query.working_time}</td> */}
                                                {/* <td className="click">{query.mistake_made_by}</td>
                                                <td className="click">{query.rectify_category}</td>
                                                <td className="click">{query.rectify_sub_category}</td> */}
                                                <td className="click">{query.reason}</td>
                                            </tr>
                                        );
                                    }
                                ) : ""}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}